module.exports = __webpack_public_path__ + "img/step_bottom_separate.1e2daea0.svg";